import React from "react";
import PluginPlaceholder from "../../../pluginsInfrastructure/PluginPlaceholder";
import { Placeholder } from "../../../pluginsInfrastructure/PluginRegistryTypes";
import { Box, Row, useScreenClass } from "@vp/swan";
import { PageStaticDataContext } from "../../../contexts/PageStaticDataContextProvider";
import { ProductBuilderSelection } from "../../../types/ProductBuilderTypes";
import { getPaddingRequirement } from "../../../utils/RangeAttributes";
import BuilderOption from "./BuilderOption";
import { BffDataContext } from "../../../contexts/BffDataContextProvider";
import { getAction } from "../../../services/siteflow";
import { getScreenClass } from "../../../utils/screenClass";
import { ensureUserTestId } from "@vp/ab-test-cookie";
import QuantityDropdown from "./QuantityDropdown";
import useGetStudioDocumentUrl from "../../../hooks/useGetStudioDocumentUrl";
import { useExperimentsContext } from "../../../contexts/ExperimentsProvider";
import { RevisedDesignFirstFlowContext } from "../../../utils/abTests/abTests";
import { isEmpty } from "lodash";
import TemplateOptionBuilder from "./TemplateOptionBuilder";
import { getColorForSwatches } from "../../../utils/Colors";

const ProductConfigurator = () => {
  let templateSelections;
  const { useExperiment } = useExperimentsContext();
  const pageContext = React.useContext(PageStaticDataContext);
  const productBuilderSelections = pageContext.productBuilderOptions.selections;
  const { tenant, locale, mpv } = pageContext;
  const { temporarilyOutOfStock } = React.useContext(BffDataContext);
  const { studioDocumentUrl } = useGetStudioDocumentUrl();

  let removePadding = false;

  const builderData = pageContext.productBuilder;
  const useQuantityDropdown = builderData.useQuantityDropdown;

  const [bulkOrderUrl, setBulkOrderUrl] = React.useState<string | undefined>();

  const { isMobile } = getScreenClass(useScreenClass());
  const revisedDesignFirstFlowVariation = useExperiment(RevisedDesignFirstFlowContext);
  if (revisedDesignFirstFlowVariation === "test") {
    templateSelections = getColorForSwatches(locale);
  }
  React.useEffect(() => {
    let mounted = true;
    const getBulkOrderUrl = async () => {
      const siteflowResponse = await getAction({
        tenant,
        culture: locale,
        flowAction: "bulkorder",
        productKey: mpv.coreProductId,
        version: mpv.version,
        optionValues: {},
        quantity: undefined,
        optimizelyEndUserId: ensureUserTestId(),
        isMobile,
        urlTokens: {
          documentUrl: studioDocumentUrl,
        },
        mpvId: mpv.mpvId,
      });
      if (mounted) {
        setBulkOrderUrl(siteflowResponse?.url);
      }
    };
    getBulkOrderUrl();
    return () => {
      mounted = false;
    };
  }, [isMobile]);

  return (
    <Box mb={5}>
      {revisedDesignFirstFlowVariation === "test" &&
        templateSelections &&
        !isEmpty(templateSelections) && (
          <TemplateOptionBuilder
            templateSelections={templateSelections}
            index={0}
            disabled={false}
            removePadding={false}
          ></TemplateOptionBuilder>
        )}
      {productBuilderSelections.length > 0 && (
        <Row className="controls-row">
          {productBuilderSelections.map((selection: ProductBuilderSelection, index: number) => {
            removePadding = getPaddingRequirement(selection.selectionStyle, removePadding);
            return (
              <BuilderOption
                index={index}
                selection={selection}
                removePadding={removePadding}
                key={`option-${index}`}
                disabled={temporarilyOutOfStock}
              />
            );
          })}
        </Row>
      )}

      <div className="controls-row">
        <PluginPlaceholder placeholderType={Placeholder.QuantityDropdown}>
          {useQuantityDropdown && (
            <QuantityDropdown builderData={builderData} bulkOrderUrl={bulkOrderUrl} />
          )}
        </PluginPlaceholder>
      </div>
    </Box>
  );
};

export default ProductConfigurator;
